document.addEventListener("DOMContentLoaded", function() {
  let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

  if ("IntersectionObserver" in window) {
    let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          lazyImage.classList.remove("lazy");
          lazyImage.classList.add("loaded");
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });

    lazyImages.forEach(function(lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  } else {
    // Fallback for browsers that don't support IntersectionObserver
    let lazyLoad = function() {
      lazyImages.forEach(function(lazyImage) {
        if (lazyImage.getBoundingClientRect().top < window.innerHeight && lazyImage.getBoundingClientRect().bottom > 0 && getComputedStyle(lazyImage).display !== "none") {
          lazyImage.src = lazyImage.dataset.src;
          lazyImage.classList.remove("lazy");
          lazyImage.classList.add("loaded");
          lazyImages = lazyImages.filter(function(image) {
            return image !== lazyImage;
          });

          if (lazyImages.length === 0) {
            document.removeEventListener("scroll", lazyLoad);
            window.removeEventListener("resize", lazyLoad);
            window.removeEventListener("orientationchange", lazyLoad);
          }
        }
      });
    };

    document.addEventListener("scroll", lazyLoad);
    window.addEventListener("resize", lazyLoad);
    window.addEventListener("orientationchange", lazyLoad);
  }
});

$(document).ready(function(){
   // $(document).on("click",".rebuy-product-checkbox",function () {
      
   //  var $productBlock = $(this).closest('.rebuy-product-block');
   //  $productBlock.toggleClass('is-selected');
    
   //    var selectedCount = $(".rebuy-product-block.is-selected").length;
   //    var selectedIndex = $(".rebuy-product-block.is-selected").index($productBlock);
   //    var unSelectedIndex = $(this).index();
   //      if(selectedIndex){
   //    $(".rebuy-bundle__image").eq(selectedIndex).find(".rebuy-bundle__image-divider .fa-plus").addClass("fa-minus")
   //   $(".rebuy-bundle__image").eq(selectedIndex).find(".rebuy-bundle__image-divider .fa-plus").removeClass("fa-plus")
   //      }
   //   else{
   //      $(".rebuy-bundle__image").eq(unSelectedIndex).find(".rebuy-bundle__image-divider .fa-plus").addClass("fa-minus")
   //     $(".rebuy-bundle__image").eq(unSelectedIndex).find(".rebuy-bundle__image-divider .fa-plus").removeClass("fa-plus")
   //   }
   //    if (selectedCount === 0) {
   //        $(".shopify-block").removeClass('active-bundle-home');
   //    } else {
   //        $(".shopify-block").addClass('active-bundle-home');
   //    }
   //  })

// $(document).on("click", ".rebuy-product-checkbox", function () {
//     var $productBlock = $(this).closest('.rebuy-product-block');
//     $productBlock.toggleClass('is-selected');
    
//     var selectedCount = $(".rebuy-product-block.is-selected").length;
    
//     // Loop through all elements with the class '.rebuy-bundle__image'
//     $(".rebuy-bundle__image").each(function(index) {
//         // Check if the corresponding product block is selected
//         if ($(".rebuy-product-block").eq(index).hasClass('is-selected')) {
//             // If selected, add fa-minus class and remove fa-plus class
//             $(this).find(".rebuy-bundle__image-divider .fa-plus").removeByContent("ADD");
//         } else {
//             // If not selected, add fa-plus class and remove fa-minus class
//             $(this).find(".rebuy-bundle__image-divider .fa-plus").after("ADD");
//         }
//     });
$(document).on("click", ".rebuy-product-checkbox", function () {
      var $this= $(this)
      var $productBlock = $this.closest('.rebuy-product-block');
      $productBlock.toggleClass('is-selected');
      var selectedCount = $(".rebuy-product-block.is-selected").length;
      var  selectedClass = $this.closest('.is-selected').length
      var imageId = $productBlock.find('.rebuy-bundle__image-divider .far')
       if(selectedClass == 1)
       {
            imageId.removeClass('fa-plus');
             imageId.addClass('fa-minus');
             imageId.next('span').remove();  
       }
      else
       {
          imageId.removeClass('fa-minus');
          imageId.addClass('fa-plus');
           if (!imageId.next('span').hasClass('add-text')) 
           {
                imageId.after('<span class="add-text">Add</span>');
          }
      }
    if (selectedCount === 0) {
        $(".rebuy_bundle_bg").removeClass('active-bundle-home');
    } else {
        $(".rebuy_bundle_bg").addClass('active-bundle-home');
    }
});
  });
       setTimeout(function () {
         var selectedCount = $(".rebuy-product-block.is-selected").length;
        // $(".rebuy-bundle__image-divider .fa-plus").after('<span>Add</span>')
        if (selectedCount === 0) {
            $(".rebuy_bundle_bg").removeClass('active-bundle-home');
        } else {
            $(".rebuy_bundle_bg").addClass('active-bundle-home');
        }
      },1000);


$(document).ready(function() {
           
        var checkintrvldata = setInterval(function(){
        if ($(".rebuy-bundle__image").length !== 0) {
            $(".rebuy-bundle__image-divider .fa-plus").after('<span class="add-text">Add</span>');
            var html = $(".rebuy-bundle__image-divider").prop('outerHTML');
            $(".rebuy-bundle__items").find('.rebuy-product-info').append(html);
            clearInterval(checkintrvldata); // Stop the interval
        }
    }, 300);
});
